<template>
    <div>
        <div class="row margin__top__20">
            <div class="col-md-12 col-xs-12">
                <AddressSearch v-on:AddressChanged="AddressChanged" :SearchId="'Practices'" :placeholder="'Zip, City or State'" />
            </div>
        </div>
        <div class="row margin__top__20">
            <div class="col-md-12 col-xs-12 practice__list ">
                <div @click="PracticeSelected(clientpractice)" :class="{'selected':clientpractice==selectedPractice}" class="border__bottom__neutral-3 padding__10  practice__details " v-for="(clientpractice,index) in orderClientPractices" v-bind:key="index">
                    <ClientPracticeDetail :clientPractice="clientpractice" />
                </div>
            </div>
        </div>
        <div class="row margin__top__20 margin__bottom__50">
            <div class="col-md-6 col-sm-6 col-xs-6">
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__primary pull-right" @click="MoveToNextPage()" :disabled="selectedPractice==null">
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressSearch from '../components/ClientPracticeAddressSearch'
import ClientPracticeDetail from '../components/ClientPracticeDetail'

export default {
    name: "Practices",
    components: { AddressSearch, ClientPracticeDetail },
    created() {
        this.$store.dispatch('SetPageNumber', 1);
    },
    methods: {
        AddressChanged(place) {
            if (place.geometry) {
                this.$store.dispatch('UpdateDistances', place);
            }
        },
        MoveToNextPage() {
            this.$router.push({ name: 'PetOwnerDetails' })
        },
        PracticeSelected(selectedPractice) {
            if (selectedPractice.PracticeId == 65490) {
                window.location.href = "https://book.vetspire.com/thrive?locationId=24"
                return;
            }
            
            if(selectedPractice.PracticeId == 65607) {
                window.location.href = "https://book.vetspire.com/thrive?locationId=68"
                return;
            }
            this.$store.dispatch('ResetDate');
            this.$store.dispatch('ResetServices');
            this.$store.dispatch('SetRequestedServices', selectedPractice.RequestedServices);
            this.$store.dispatch('PracticeSelected', selectedPractice);
            this.$store.dispatch('InitializeSpecies', selectedPractice);
            this.$router.push({ name: 'PetOwnerDetails' })
        },
    },
    computed: {
        ...mapGetters({
            clientPractices: 'clientPractices',
            selectedPractice: 'selectedPractice'
        }),
        orderClientPractices: function () {
            return this.clientPractices.sort(function (a, b) {
                return parseFloat(a.Mile) - parseFloat(b.Mile);
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Practices.vue